import { useEffect } from "react";
import { osName, osVersion, browserName, browserVersion, isMobile, mobileModel } from "react-device-detect";
import { v4 as uuidv4 } from "uuid";
import useLocalStorage from "./useLocalStorage";

const useBaristaStation = () => {
  const [station, setStation] = useLocalStorage("barista-station", {
    id: uuidv4(),
    device_detail: isMobile ? mobileModel : `${browserName} ${browserVersion} on ${osName} ${osVersion}`,
    is_mobile: isMobile,
  });

  useEffect(() => {
    setStation(station);
    // eslint-disable-next-line
  }, [station]);

  return { station };
};

export default useBaristaStation;
